import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API_BASE } from "../lib/config";
import home from "../content/home.json";

const FeaturedChantings = () => {
  const { featured } = home;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_BASE}/stotrams`, { params: { featured: true } })
      .then((res) => {
        setItems((res.data || []).slice(0, 4));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <section
      id="featured"
      data-testid="featured-chantings-section"
      className="py-16 md:py-20 bg-ivory-deeper"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <p className="text-xs tracking-[0.32em] uppercase font-medium text-muted_gold">
            {featured.overline}
          </p>
          <h2 className="mt-4 font-heading font-normal text-charcoal text-4xl sm:text-5xl md:text-6xl tracking-tight">
            {featured.heading}
          </h2>
          <div className="mt-6 mx-auto w-12 h-px bg-muted_gold" />
        </div>

        <div
          data-testid="featured-grid"
          className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-6 max-w-7xl mx-auto"
        >
          {loading &&
            Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="bg-ivory border border-charcoal/10 h-32 sm:h-auto sm:aspect-square animate-pulse w-full max-w-sm justify-self-center"
              />
            ))}
          {!loading &&
            items.map((s) => (
              <Link
                key={s.id}
                to={`/stotrams/${s.slug}`}
                data-testid={`featured-card-${s.slug}`}
                className="museum-plaque group flex flex-row sm:flex-col bg-ivory border border-charcoal/10 overflow-hidden w-full max-w-sm justify-self-center"
              >
                <div className="w-32 h-32 flex-shrink-0 sm:w-full sm:h-auto sm:aspect-square overflow-hidden bg-ivory-deeper">
                  <img
                    src={s.image_url}
                    alt={`${s.title} — devotional artwork`}
                    className="plaque-image w-full h-full object-contain"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 sm:p-5 md:p-6 flex flex-1 flex-col gap-2 sm:gap-3">
                  <div>
                    <p className="text-xs tracking-[0.32em] uppercase font-semibold text-muted_gold">
                      {s.deity}
                    </p>
                    <h3 className="mt-2 font-heading font-normal text-xl sm:text-2xl text-charcoal leading-tight">
                      {s.title}
                    </h3>
                    <p className="mt-1 indic-text italic text-base sm:text-lg text-charcoal-soft">
                      {s.sanskrit_title}
                    </p>
                    <p className="hidden sm:block mt-3 text-charcoal-soft text-base leading-relaxed line-clamp-2 xl:line-clamp-3">
                      {s.description}
                    </p>
                  </div>
                  <div className="flex items-center justify-end border-t border-charcoal/15 pt-3 sm:pt-4 mt-auto">
                    <span className="text-xs tracking-[0.24em] uppercase font-medium text-charcoal group-hover:text-muted_gold transition-colors duration-500">
                      Open →
                    </span>
                  </div>
                </div>
              </Link>
            ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to={featured.cta.to}
            data-testid="explore-library-cta"
            className="inline-block border border-charcoal/40 text-charcoal px-10 py-4 text-xs tracking-[0.32em] uppercase font-medium hover:border-muted_gold hover:text-muted_gold transition-colors duration-500"
          >
            {featured.cta.label}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedChantings;
